// extracted by mini-css-extract-plugin
export default {"root":"EditListingListingDetailsPannel_root__IzLx3","form":"EditListingListingDetailsPannel_form__NRqMl","title":"EditListingListingDetailsPannel_title__avnVh"};